<template>
  <div class="dropdown" ref="dropdown">
    <button 
      class="btn btn-link p-2" 
      type="button" 
      @click="toggleDropdown"
      ref="dropdownButton"
    >
      <div class="notification-bell">
        <i class="fa fa-bell fa-lg" style="color: #ffffff;" aria-hidden="true"></i>
        <span 
          class="badge" 
          v-if="typeof notificationCount === 'number' && notificationCount > 0" 
          :class="{ 'badge-animation-fade': typeof notificationCount === 'number' && notificationCount > 0 }"
        > 
          {{ notificationCount }} 
        </span>      
      </div>
    </button>
    
    <div 
      class="dropdown-menu" 
      :class="{ 'show': isOpen }"
      v-show="isOpen"
    >
      <h6 class="dropdown-header">Notificações Recentes</h6>
      
      <div class="dropdown-item-text text-center text-all-notification" @click="markAllAsRead">
        Marcar todas como lida
      </div>
      
      <hr class="dropdown-divider">
      
      <div class="calc-card-dropdown">
        <NotificationItem
          v-for="item in list"
          :key="item.id"
          :type="item.type"
          :date="item.date"
          :id="item.id"
          :isRead="item.isRead"
          @itemRead="handleItemRead"
        />
      </div>
      
      <hr class="dropdown-divider">
      
      <div class="d-flex justify-content-center align-items-center py-2">
        <router-link
          id="linkNotification"
          class="text-all-notification text-decoration-none text-center"
          to="/notification"
          @click.native="closeDropdown"
        >
          Ver todas
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import request from "../../request/request";
import NotificationItem from "./NotificationItem";
import { eventPageEventPath, eventUserPath } from "../../router/ApiPaths";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "NotificationsHeader",
  extends: request,
  components: {
    NotificationItem,
  },
  data() {
    return {
      list: [],
      limit: 10,
      isOpen: false,
    };
  },
  computed: {
    ...mapGetters({
      notificationCount: "hasNotification",
    }),
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen;
      if (this.isOpen) {
        this.find();
      }
    },
    closeDropdown() {
      this.isOpen = false;
    },
    handleClickOutside(event) {
      if (this.$refs.dropdown && !this.$refs.dropdown.contains(event.target)) {
        this.closeDropdown();
      }
    },
    async find() {
      this.get(`${eventPageEventPath}${this.limit}?category=A`).then((data) => {
        this.list = data;
      });
    },
    markAllAsRead() {
      const unreadItems = this.list.filter(item => !item.isRead);
      const updatePromises = unreadItems.map(item => this.post(eventUserPath, { eventId: item.id }));
      
      Promise.all(updatePromises).then(() => {
        this.list.forEach(item => item.isRead = true);
        this.updateNotificationCountInStore(this.notificationCount - unreadItems.length);
        this.closeDropdown();
      });
    },
    handleItemRead(id) {
      const item = this.list.find(notification => notification.id === id);
      if (item && !item.isRead) {
        item.isRead = true;
        this.updateNotificationCountInStore(this.notificationCount - 1);
      }
    },
    ...mapActions({
      setNotification: "setNotification",
    }),
    updateNotificationCountInStore(newCount) {
      this.setNotification(newCount);
    },
  },
};
</script>

<style scoped>
.dropdown {
  position: relative;
  display: inline-block;
}

.btn {
  border: none !important;
  box-shadow: none !important;
  background: transparent !important;
}

.btn:focus,
.btn:active,
.btn:hover {
  box-shadow: none !important;
  background: transparent !important;
  border: none !important;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  left: auto;
  z-index: 1000;
  display: none;
  min-width: 340px;
  max-width: 340px;
  padding: 0.5rem 0;
  margin: 0.125rem 0 0;
  font-size: 0.875rem;
  color: #212529;
  text-align: left;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.175);
  transform: translateX(0);
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  font-size: 17px;
  font-weight: 600 !important;
  color: #334257;
  padding: 0.5rem 1rem;
  margin: 0;
  white-space: nowrap;
}

.dropdown-divider {
  height: 0;
  margin: 0.5rem 0;
  overflow: hidden;
  border-top: 1px solid #e9ecef;
}

.calc-card-dropdown {
  max-height: calc(90vh - 200px);
  min-height: 200px;
  overflow-y: auto;
}

.dropdown-item-text {
  font-weight: 600;
  padding: 0.25rem 1rem;
  margin: 0;
}

.text-all-notification {
  font-size: 14px;
  color: #42526e;
  cursor: pointer;
}

.text-all-notification:hover {
  color: #2c3e50;
}

.notification-bell {
  position: relative;
}

.notification-bell .badge {
  position: absolute;
  top: -5px;
  right: -10px;
  background-color: #ff0000;
  color: #ffffff;
  border-radius: 50%;
  padding: 2px 6px;
  font-size: 10px;
}

.badge-animation-fade {
  animation: fade 1s infinite;
}

@keyframes fade {
  0% { opacity: 1; }
  50% { opacity: 0.5; }
  100% { opacity: 1; }
}
</style>
